import Card from '../../atoms/surfaces/Card'
import Label from '../../atoms/display/Label'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Rating from '../../atoms/inputs/Rating'
import { PhoneIcon } from '../../atoms/display/Icons'
import useRouter from '../../../hooks/useRouter'
import Button from '../../atoms/inputs/Button'
import Link from '../../atoms/navigation/Link'
import ClientMoneyspaceTable from './ClientMoneyspaceTable'
import { ClientDetail } from '../../../types/Company'
import { Moneyspace } from '../../../types/Moneyspace'
import CompanyWorkAreasView from './CompanyWorkAreasView'
import CompanyConstructionsView from './CompanyConstructionsView'

type Props = {
  clientDetail: ClientDetail
  moneyspaces: Moneyspace[]
  selectedMoneyspaceIds?: string[]
  highlightConstructionTypeIds: string[]
  highlightAreaIds: string[]
  onSelect?: (selected: boolean, moneyspaceId: string) => void
}

export default function ClientSearchResultCard({
  clientDetail,
  moneyspaces,
  selectedMoneyspaceIds,
  highlightConstructionTypeIds,
  highlightAreaIds,
  onSelect,
}: Props) {
  const { settingsClient } = useRouter()

  return (
    <Card
      size="lg"
      header={
        <FlexRow align="center">
          <FlexRow align="flex-end" wrap>
            <Label text={clientDetail.name} variant="title" />
            {clientDetail.representativeName && (
              <FlexRow align="center">
                <Label text="代表者" variant="subtitle" />
                <Label text={clientDetail.representativeRole ?? ''} />
                <Label text={clientDetail.representativeName} />
              </FlexRow>
            )}
          </FlexRow>
          <Rating max={3} value={clientDetail.evaluation?.totalPoint} readOnly />
        </FlexRow>
      }
      onClickHeader={() => settingsClient(clientDetail.id)}
      actions={
        <FlexRow justify="flex-end" width="100%">
          <Button height="small" onClick={() => settingsClient(clientDetail.id)}>
            詳細
          </Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        {clientDetail.address && <Label text={clientDetail.address} />}
        {clientDetail.phoneNumber && (
          <FlexRow align="center">
            <PhoneIcon />
            <Link href={`tel:${clientDetail.phoneNumber}`}>
              <Label text={clientDetail.phoneNumber} />
            </Link>
          </FlexRow>
        )}
        <FlexRow align="center">
          <Label text="対応可能地域" variant="subtitle" whiteSpace="nowrap" />
          <CompanyWorkAreasView areaIds={clientDetail.workAreaIds} highlightAreaIds={highlightAreaIds} />
        </FlexRow>
        <FlexRow align="center">
          <Label text="対応可能工種" variant="subtitle" whiteSpace="nowrap" />
          <CompanyConstructionsView
            constructions={clientDetail.constructions}
            highlightConstructionTypeIds={highlightConstructionTypeIds}
          />
        </FlexRow>
        {moneyspaces.length > 0 && (
          <FlexColumn space={0}>
            <Label text="マネースペース" variant="caption" />
            <ClientMoneyspaceTable
              moneyspaces={moneyspaces}
              selectedMoneyspaceIds={selectedMoneyspaceIds}
              onSelect={onSelect}
            />
          </FlexColumn>
        )}
      </FlexColumn>
    </Card>
  )
}
